import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
// import { PlanComponent } from './plan/plan.component';
import { PaymentComponent } from './payment/payment.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CareerComponent } from './career/career.component';
import { ContactComponent } from './contact/contact.component';
import { SiteMapComponent } from './site-map/site-map.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { PartnersComponent } from './partners/partners.component';
// import { SubscriptionComponent } from './subscription/subscription.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { VerifymailComponent } from './verifymail/verifymail.component';
import { FaqsComponent } from './faqs/faqs.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { CorporateComponent } from './corporate/corporate.component';
import { OnboardQuestionsComponent } from './onboard-questions/onboard-questions.component';
// import { OnboardQuestionDetailComponent } from './onboard-question-detail/onboard-question-detail.component';
// import { AuthGuard } from './auth.guard';
// import { SubscriptionSignupComponent } from './signupmodule/subscription-signup/subscription-signup.component';
// import { DashboardComponent } from './dashboard/dashboard.component';
// import { MembershipComponent } from './membership/membership.component';
import { MembershipFreeComponent } from './membership-free/membership-free.component';
import { MembershipDiscountComponent } from './membership-discount/membership-discount.component';
import { VariationFitnessComponent } from './variation-fitness/variation-fitness.component';
import { LogoutComponent } from './logout/logout.component';
import { AssesmentFormComponent } from './assesment-form/assesment-form.component';
import { PointSubmissionFormComponent } from './points-submission-form/points-submission-form.component';
import { VenderSignupComponent } from './vender/vender-signup/vender-signup.component';
import { VenderSignupfreeComponent } from './vender/vender-signup-free/vender-signupfree.component';
import { VendorConfirmationComponent } from './vendor-confirmation/vendor-confirmation.component';
import { AlreadyLoggedInComponent } from './already-logged-in/already-logged-in.component';
import { B2bteamsComponent } from './b2bteams/b2bteams.component';
import { B2bteamsConfirmationComponent } from './b2bteams-confirmation/b2bteams-confirmation.component';
import { NewteamsComponent } from './newteams/newteams.component';
import { RewardscardComponent } from './rewardscard/rewardscard.component';
import { RewardsConfirmationComponent } from './rewards-confirmation/rewards-confirmation.component';

const routes: Routes = [
  { path: '', component: HomeComponent, data: { animation: 'isRight' } },
  { path: 'logout', component: LogoutComponent },
  { path: 'home', component: HomeComponent, data: { animation: 'isRight' } },
  { path: 'register/:slug', loadChildren: () => import('./signupmodule/signupmodule.module').then(obj => obj.SignupmoduleModule) },
  { path: 'register-user/:slug', loadChildren: () => import('./signupmoduleb2c/signupmoduleb2c.module').then(obj => obj.Signupmoduleb2cModule) },
  { path: 'payment', component: PaymentComponent, data: { animation: 'isRight' } },
  { path: 'privacy_policy', component: PrivacyPolicyComponent, data: { animation: 'isLeft' } },
  { path: 'terms-conditions', component: TermsConditionsComponent, data: { animation: 'isLeft' } },
  { path: 'about-us', component: AboutUsComponent, data: { animation: 'isLeft' } },
  { path: 'career', component: CareerComponent, data: { animation: 'isLeft' } },
  { path: 'contact', component: ContactComponent, data: { animation: 'isLeft' } },
  { path: 'site-map', component: SiteMapComponent },
  { path: 'partners', component: PartnersComponent },
  { path: 'workwell', component: CorporateComponent },
  { path: 'confirmation', component: PaymentConfirmationComponent, data: { animation: 'isRight' } },
  { path: 'resetpassword', component: ResetpasswordComponent, data: { animation: 'isRight' } },
  { path: 'verifymail', component: VerifymailComponent, data: { animation: 'isRight' } },
  { path: 'faqs', component: FaqsComponent, data: { animation: 'isRight' } },
  { path: 'survey', component: OnboardQuestionsComponent, data: { animation: 'isRight' } },
  { path: "membership/app", component: VariationFitnessComponent, data: { animation: 'isRight' } },
  { path: "membership/app-free", component: MembershipFreeComponent, data: { animation: 'isRight' } },
  { path: "membership/app-discount", component: MembershipDiscountComponent, data: { animation: 'isRight' } },
  { path: "points-form", component: AssesmentFormComponent },
  { path: "points-submission-form", component: PointSubmissionFormComponent },
  { path: "vendor/registration", component: VenderSignupComponent },
  { path: "vendor/signupfree", component: VenderSignupfreeComponent },
  { path: "vendor/confirmation-thankyou", component: VendorConfirmationComponent },
  { path: "alreadyloggedin", component: AlreadyLoggedInComponent },
  { path: 'b2bteams', component: B2bteamsComponent },
  { path: 'b2bteams-confirmation', component: B2bteamsConfirmationComponent },
  { path: 'newteams', component: NewteamsComponent },
  { path: 'rewards/:id', component: RewardscardComponent },
  { path: 'rewards-confirmation', component: RewardsConfirmationComponent },


  {
    path: 'search',
    loadChildren: () => import('./global-search/global-search.module').then(m => m.GlobalSearchModule)
  },
  {
    path: "activation-b2c",
    loadChildren: () => import('./activation-b2c/activation-b2c.module').then(m => m.ActivationB2cModule)
  },
  {
    path: "app-challenge",
    loadChildren: () => import('./challenge/challenge.module').then(m => m.ChallengeModule)
  },
  {
    path: "affiliate",
    loadChildren: () => import('./affiliate/affiliate.module').then(m => m.AffiliateModule)
  },
  {
    path: "assesment/form-wizard",
    loadChildren: () => import('./assesment/assesment.module').then(m => m.AssesmentModule)
  },
  {
    path: "app",
    loadChildren: () => import('./reset/reset.module').then(m => m.ResetModule)
  },
  {
    path: 'app-onboarding-guide',
    loadChildren: () => import('./app-onboarding-guide/app-onboarding-guide.module').then(m => m.AppOnboardingGuideModule)
  },
  { path: '404', component: NotfoundComponent, data: { animation: 'isRight' } },
  { path: '**', redirectTo: '404', data: { animation: 'isRight' } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
